import { useReducer } from 'react';
import { genericReducer } from '@reducers/gridReducer';

const initialState = {
  data: [],
  totalRows: 0,
};

export function useGenericReducer() {
  const [state, dispatch] = useReducer(genericReducer, initialState);

  // Função para carregar dados
  const setData = (data, totalRows) => {
    dispatch({ type: 'SET_DATA', payload: { data, totalRows } });
  };

  // Função para adicionar um item
  const addItem = (item) => {
    dispatch({ type: 'ADD_ITEM', payload: item });
  };

  // Função para adicionar uma nova linha de histórico da solicitação
  const addHistoricoSolicitacao = (item) => {
    dispatch({ type: 'ADD_ITEM', payload: item.solicitacaoHistorico });
  };

  // Função para atualizar um item
  const updateItem = (item) => {
    dispatch({ type: 'UPDATE_ITEM', payload: item });
  };

  // Função para deletar um item
  const deleteItem = (id) => {
    dispatch({ type: 'DELETE_ITEM', payload: id });
  };

  return {
    state,
    setData,
    addItem,
    addHistoricoSolicitacao,
    updateItem,
    deleteItem,
  };
}
